import { RE_UUID } from '../constants/regex';

export default (str) => {
  const matches = str.match(RE_UUID);
  if (matches && matches.length) return matches[0];
};
